module.exports = __webpack_public_path__ + "img/bg1.e5d5a0e1.png";